/* eslint-disable security/detect-object-injection */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeHeroSectionViewProps } from './moe-hero-section';

export default (props: IMoeHeroSectionViewProps) => {
    // const defaultImageSettings: Msdyn365.IImageSettings = {
    //     viewports: {
    //         xs: { q: 'w=24&h=24&m=6', w: 0, h: 0 },
    //         lg: { q: 'w=24&h=24&m=6', w: 0, h: 0 }
    //     },
    //     lazyload: true
    // };
    const _getSlot = (slotName: string): React.ReactNode[] | null => {
        const { slots } = props;
        return (slots && slots[slotName] && slots[slotName].length && slots[slotName]) || null;
    };

    const breadcrumbSlot = _getSlot('breadcrumb');
    const {
        data,
        config: { imageSource }
    } = props;
    let heroImageSource;
    let heroAltText;

    if (imageSource && imageSource.src) {
        heroImageSource = imageSource.src;
        heroAltText = imageSource.altText;
    } else {
        heroImageSource = data.product.result?.PrimaryImageUrl;
        heroAltText = data.product.result?.Name;
    }

    return (
        // <div className='moe-hero-section'>
        //     <div className='ms-moe-herosection-left'>
        //         <div className='ms-moe-herosection-left-text'>
        //             <h1 className='ms-moe-herosection__title'>{data?.product?.result?.Name}</h1>
        //             <p className='ms-moe-herosection__desc'>{data?.product?.result?.Description}</p>
        //         </div>
        //         <div className='ms-moe-herosection-left-text'>{breadcrumbSlot}</div>
        //     </div>
        //     <div className='ms-moe-herosection-bottom'>
        //         <img
        //             src={data.product.result?.PrimaryImageUrl}
        //             alt={`${data.product.result?.Name} resource image`}
        //             aria-label={`${data.product.result?.Name} resource image`}
        //         />
        //     </div>
        // </div>
        <section tabIndex={0} className='moe-resource-hero'>
            <div className='moe-resource-hero__content'>
                <div className='moe-resource-hero__content-overflow'>
                    <h2>{data?.product?.result?.Name}</h2>
                    <p>{data?.product?.result?.Description}</p>
                </div>
                {breadcrumbSlot}
            </div>

            <div className='moe-resource-hero__image'>
                <img src={heroImageSource} alt={heroAltText} aria-label={heroAltText} className='lazyloaded' />
            </div>
        </section>
    );
};
